<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="开票信息" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini">
								<el-form-item label="公司名称">
									<el-input v-model="searchForm.company_name" placeholder="请填写公司名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="业务类型">
									<el-select v-model="searchForm.type" placeholder="请选择" clearable style="width: 100%;">
										<el-option label="供应商" :value="1"></el-option>
										<el-option label="客户" :value="2"></el-option>
										<el-option label="平台" :value="3"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.pay_type" placeholder="请选择" clearable style="width: 100%;">
										<el-option label="待提交" :value="1"></el-option>
										<el-option label="待审核" :value="2"></el-option>
										<el-option label="被驳回" :value="3"></el-option>
										<el-option label="正常" :value="4"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="是否停用">
									<el-select v-model="searchForm.is_disable" placeholder="请选择" style="width: 100%;" clearable>
										<el-option v-for="item in options.is_disable_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/resources/resources/ctinvoice') || $parent.$parent.isAuthAction('admin/customers/export/exportinvoiceexcel')">
								<div>
									<el-button type="primary" size="mini" @click="addInvoiceOpen"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/ctinvoice')">添加开票信息</el-button>
								</div>
								<div style="margin-right:10px">
									<el-link type="primary" icon="el-icon-download" :disabled="isDownloading" @click="exportData"
										v-if="$parent.$parent.isAuthAction('admin/customers/export/exportinvoiceexcel')">{{ isDownloading ?
											'下载中...' : '下载' }}</el-link>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" row-key="id" border stripe ref="table"
									v-loading="tableloading" highlight-current-row :height="tableHeight">
									<el-table-column fixed prop="id" label="ID" width="50">
									</el-table-column>
									<el-table-column prop="relevance_txt" label="发票所属" width="80">
									</el-table-column>
									<el-table-column fixed prop="company_name" label="公司名称" min-width="250">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.company_name }}</el-link>
										</template>
									</el-table-column>
									<el-table-column prop="ird" label="税号" min-width="220">
									</el-table-column>
									<el-table-column prop="address" label="地址" :show-overflow-tooltip="true" min-width="200">
									</el-table-column>
									<el-table-column prop="phone" label="电话" min-width="120">
									</el-table-column>
									<el-table-column prop="bank_card" label="银行卡号" min-width="200">
									</el-table-column>
									<el-table-column prop="bank_branch_txt" label="开户行" :show-overflow-tooltip="true" min-width="200">
									</el-table-column>
									<el-table-column prop="invoice_type_txt" label="发票类型" min-width="100">
									</el-table-column>
									<el-table-column prop="refund_account_txt" label="回款银行" width="100">
									</el-table-column>
									<el-table-column prop="invoice_prove" label="营业执照" align="center" width="100">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.idcard_prove" target="_blank" style="font-size: 12px;"
												v-if="scope.row.idcard_prove">预览</el-link>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column prop="invoice_prove" label="开户许可证" align="center" width="100">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.invoice_prove" target="_blank" style="font-size: 12px;"
												v-if="scope.row.invoice_prove">预览</el-link>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column prop="taxpayer_prove" label="一般纳税人证明" align="center" width="110">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.taxpayer_prove" target="_blank" style="font-size: 12px;"
												v-if="scope.row.taxpayer_prove">预览</el-link>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column prop="fp_attachment" label="发票证明" align="center" width="80">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.fp_attachment" target="_blank" style="font-size: 12px;"
												v-if="scope.row.fp_attachment">预览</el-link>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column prop="fp_attachment" label="关联证明" align="center" width="80">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.guanlian_prove" target="_blank" style="font-size: 12px;"
												v-if="scope.row.guanlian_prove">预览</el-link>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column prop="rid_txt" label="客户/供应商/平台" :show-overflow-tooltip="true" min-width="200">
									</el-table-column>
									<el-table-column prop="uid_txt" label="创建人" width="80">
									</el-table-column>
									<el-table-column prop="create_time" label="创建时间" width="150">
									</el-table-column>
									<el-table-column prop="is_disable_txt" label="是否启用" width="80">
									</el-table-column>
									<el-table-column fixed="right" prop="is_default" label="是否默认" align="center" width="80">
										<template slot-scope="scope">
											<span v-if="scope.row.is_default == 1">是</span>
											<span v-if="scope.row.is_default == 0">否</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" label="状态" align="center" width="80">
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/editinvoice') || $parent.$parent.isAuthAction('admin/resources/resources/delinvoice') || $parent.$parent.isAuthAction('admin/resources/resources/invoicesubmit') || $parent.$parent.isAuthAction('admin/resources/resources/invoicedefault') || $parent.$parent.isAuthAction('admin/resources/resources/disableinvoice')"
										width="220">
										<template slot-scope="scope">
											<el-button :disabled="scope.row.status != 4" @click="handleTableDisableOpen(scope.row)" type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/resources/resources/disableinvoice')">{{ scope.row.is_disable == 2 ? '启用' : '停用' }}</el-button>
											<template v-if="scope.row.status == 1 || scope.row.status == 3">
												<el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/resources/resources/editinvoice')">编辑</el-button>
												<el-button @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger"
													v-if="$parent.$parent.isAuthAction('admin/resources/resources/delinvoice')">删除</el-button>
												<el-button @click="handleTableFlow(scope.row)" type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/resources/resources/invoicesubmit')">提交审批</el-button>
											</template>
											<template v-else>
												<el-button disabled type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/resources/resources/editinvoice')">编辑</el-button>
												<el-button disabled type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/resources/resources/delinvoice')">删除</el-button>
												<el-button disabled type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/resources/resources/invoicesubmit')">提交审批</el-button>
											</template>
											<el-button type="text" :disabled="!(scope.row.status == 4 && scope.row.is_default == 0 && scope.row.is_disable == 1)"
												:size="size" @click="isDefault(scope.row)"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/invoicedefault')">设置默认</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--添加发票信息-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" v-loading="loading"
			:close-on-press-escape='false' :wrapperClosable='false' size="60%">
			<div class="drawer-header">
				<div class="header-title">
					<span>添加开票信息</span>
					<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
					<div>
						<el-form-item label="业务类型" key="type" prop="type">
							<el-select v-model="addForm.type" placeholder="请选择" clearable style="width: 100%;" @change="getRid()">
								<el-option label="供应商" :value="1"></el-option>
								<el-option label="客户" :value="2"></el-option>
								<el-option label="平台" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="addForm.ridLabel" key="rid" v-if="addForm.type" prop="rid">
							<el-select v-model="addForm.rid" placeholder="请选择" clearable style="width: 100%;" filterable remote
								reserve-keyword :remote-method="getRid">
								<el-option v-for="item in options.rid_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="公司名称" prop="company_name">
							<el-input v-model="addForm.company_name" placeholder="请填写公司名称" clearable maxlength="30"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="公司税号" prop="ird">
							<el-input v-model="addForm.ird" placeholder="请填写公司税号" clearable maxlength="30" show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="公司地址" prop="address">
							<el-input v-model="addForm.address" placeholder="请填写公司地址" clearable maxlength="50"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="电话" prop="phone">
							<el-input v-model="addForm.phone" placeholder="请填写电话" clearable></el-input>
						</el-form-item>
						<el-form-item label="开户行及支行" prop="bank_branch" key="bank_branch">
							<el-col :span="11">
								<el-select v-model="addForm.bank_of_deposit" filterable
									@change="requestZh(addForm.bank_of_deposit, 'clear')" placeholder="请选择开户行" clearable
									style="width: 100%;">
									<el-option v-for="item in options.khh_options" :key="item.id" :label="item.bank_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col class="line" style="width:20px; text-align: center;">-</el-col>
							<el-col :span="12">
								<el-select v-model="addForm.bank_branch" filterable allow-create default-first-option
									placeholder="请选择支行" clearable style="width: 100%;">
									<el-option v-for="item in options.zh_options" :key="item.id" :label="item.bank_name" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="银行卡号" prop="bank_card">
							<el-input v-model="addForm.bank_card" placeholder="请填写银行卡号" clearable maxlength="30"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="发票类型" key="invoice_type" prop="invoice_type">
							<el-select v-model="addForm.invoice_type" placeholder="请选择" clearable style="width: 100%;">
								<el-option label="普票" :value="1"></el-option>
								<el-option label="专票" :value="2"></el-option>
								<el-option label="形式发票" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="发票率" prop="invoice_rate" key="invoice_rate">
							<el-input v-model="addForm.invoice_rate" placeholder="请填写发票率" clearable>
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
						<el-form-item label="回款账户" prop="refund_account" key="refund_account" v-if="addForm.type == 2">
							<el-select v-model="addForm.refund_account" placeholder="请选择回款账户" clearable style="width: 100%;"
								filterable remote reserve-keyword :remote-method="getRemittanceBanck">
								<el-option v-for="item in options.refund_account_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="营业执照" key="idcard_prove" prop="idcard_prove" v-if="addForm.type!=3">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.idcard_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'idcard_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'addForm', 'idcard_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="开户许可证" key="invoice_prove" prop="invoice_prove">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.invoice_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'invoice_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'addForm', 'invoice_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="一般纳税人证明" key="taxpayer_prove" prop="taxpayer_prove">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.taxpayer_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'taxpayer_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'addForm', 'taxpayer_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="发票证明" prop="fp_attachment" key="fp_attachment">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.fp_attachment"
								:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'fp_attachment', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'addForm', 'fp_attachment', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="关联证明" key="guanlian_prove" v-if="addForm.type == 1 || addForm.type == 2">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.guanlian_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'guanlian_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'addForm', 'guanlian_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button type="primary" @click="addInvoice()" :size='size'>提交</el-button>
				<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
			</div>
		</el-drawer>
		<!--编辑发票信息-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" v-loading="loading"
			:close-on-press-escape='false' :wrapperClosable='false' size="60%">
			<div class="drawer-header">
				<div class="header-title">
					<span>编辑开票信息</span>
					<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
					<div>
						<el-form-item label="业务类型" key="type" prop="type">
							<el-select v-model="editForm.type" placeholder="请选择" clearable style="width: 100%;"
								@change="getRidedit('clear')">
								<el-option label="供应商" :value="1"></el-option>
								<el-option label="客户" :value="2"></el-option>
								<el-option label="平台" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="editForm.ridLabel" key="rid" v-if="editForm.type" prop="rid">
							<el-select v-model="editForm.rid" placeholder="请选择" style="width: 100%;" clearable filterable remote
								reserve-keyword :remote-method="(query) => getRidedit('clear', query)">
								<el-option v-for="item in options.rid_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="公司名称" prop="company_name">
							<el-input v-model="editForm.company_name" placeholder="请填写公司名称" clearable maxlength="30"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="税号" prop="ird">
							<el-input v-model="editForm.ird" placeholder="请填写税号" clearable maxlength="30" show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="公司地址" prop="address">
							<el-input v-model="editForm.address" placeholder="请填写公司地址" clearable maxlength="50"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="电话" prop="phone">
							<el-input v-model="editForm.phone" placeholder="请填写电话" clearable maxlength="30"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="开户行及支行" prop="bank_branch" key="bank_branch">
							<el-col :span="11">
								<el-select v-model="editForm.bank_of_deposit" @change="requestZh(editForm.bank_of_deposit, 'clear')"
									placeholder="请选择开户行" filterable clearable style="width: 100%;">
									<el-option v-for="item in options.khh_options" :key="item.id" :label="item.bank_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col class="line" style="width:20px; text-align: center;">-</el-col>
							<el-col :span="12">
								<el-select v-model="editForm.bank_branch" filterable allow-create default-first-option
									placeholder="请选择支行" clearable style="width: 100%;">
									<el-option v-for="item in options.zh_options" :key="item.id" :label="item.bank_name" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="银行卡号" prop="bank_card">
							<el-input v-model="editForm.bank_card" placeholder="请填写银行卡号" clearable></el-input>
						</el-form-item>
						<el-form-item label="发票类型" key="invoice_type" prop="invoice_type">
							<el-select v-model="editForm.invoice_type" placeholder="请选择" clearable style="width: 100%;">
								<el-option label="普票" :value="1"></el-option>
								<el-option label="专票" :value="2"></el-option>
								<el-option label="形式发票" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="发票率" prop="invoice_rate" key="invoice_rate">
							<el-input v-model="editForm.invoice_rate" placeholder="请填写发票率" clearable>
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
						<el-form-item label="回款账户" prop="refund_account" key="refund_account" v-if="editForm.type == 2">
							<el-select v-model="editForm.refund_account" placeholder="请选择回款账户" clearable style="width: 100%;"
								filterable remote reserve-keyword :remote-method="getRemittanceBanck">
								<el-option v-for="item in options.refund_account_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="营业执照" key="idcard_prove" prop="idcard_prove">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.idcard_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'idcard_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'editForm', 'idcard_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="开户许可证" key="invoice_prove" prop="invoice_prove">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.invoice_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'invoice_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'editForm', 'invoice_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="一般纳税人证明" key="taxpayer_prove" prop="taxpayer_prove">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.taxpayer_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'taxpayer_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'editForm', 'taxpayer_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="发票证明" prop="fp_attachment" key="fp_attachment">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.fp_attachment"
								:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'fp_attachment', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'editForm', 'fp_attachment', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="关联证明" key="guanlian_prove" v-if="editForm.type == 1 || editForm.type == 2">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.guanlian_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'guanlian_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'editForm', 'guanlian_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button type="primary" @click="handleTableEdit()" :size='size'>提交</el-button>
				<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
			</div>
		</el-drawer>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			dialogImageUrl: '',
			dialogVisibleImg: false,
			isDownloading: false,
			addFormVisiable: false,
			editFormVisiable: false,
			loading: true,
			tableloading: true,
			activeName: 'first',
			size: 'mini',
			options: {
				is_disable_options: [
					{
						value: 1,
						label: '启用'
					}, {
						value: 2,
						label: '停用'
					}],
				rid_options: [],
				refund_account_options: [],
				khh_options: [],
				zh_options: []
			},
			searchForm: {
				company_name: '',
				type: '',
				pay_type: '',
				is_disable:''
			},
			resetSearch: {
				company_name: '',
				type: '',
				pay_type: '',
				is_disable:''
			},
			addForm: {
				type: '',
				rid: '',
				ridLabel: '',
				company_name: '',
				address: '',
				phone: '',
				bank_of_deposit: '',
				bank_branch: '',
				bank_card: '',
				invoice_type: '',
				invoice_type: '',
				refund_account: '',
				idcard_prove: [],
				invoice_prove: [],
				taxpayer_prove: [],
				fp_attachment: [],
				guanlian_prove: []
			},
			editForm: {
				type: '',
				rid: '',
				ridLabel: '',
				company_name: '',
				ird: '',
				address: '',
				phone: '',
				bank_of_deposit: '',
				bank_branch: '',
				bank_card: '',
				invoice_type: '',
				invoice_type: '',
				refund_account: '',
				idcard_prove: [],
				invoice_prove: [],
				taxpayer_prove: [],
				fp_attachment: [],
				guanlian_prove: []
			},
			rules: {
				addForm: {
					'type': [
						{ required: true, message: '请选择业务类型', trigger: ['change'] }
					],
					'rid': [
						{ required: true, message: '请选择', trigger: ['change'] }
					],
					'address': [
						{ required: true, message: '请填写公司地址', trigger: ['blur'] }
					],
					'company_name': [
						{ required: true, message: '请填写公司名称', trigger: ['blur'] }
					],
					'ird': [
						{ required: true, message: '请填写税号', trigger: ['change', 'blur'] },
						{
							pattern: /^[A-Za-z0-9]+$/,
							message: '只能包含字母和数字',
							trigger: ['change', 'blur'],
						}
					],
					'phone': [
						{ required: true, message: '请填写电话号码', trigger: ['change', 'blur'] },
						{
							validator: (rule, value, callback) => {
								const mobileRegex = /^1[3-9]\d{9}$/; // 手机号
								const landlineRegex = /^(0\d{2,3}-)?\d{7,8}$/; // 座机号
								if (!mobileRegex.test(value) && !landlineRegex.test(value) && value) {
									callback(new Error('请输入有效的手机号或座机号'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bank_card': [
						{
							required: true, validator: (rule, value, callback) => {
								const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
								if (!value) {
									callback(new Error('请填写银行卡号'));
								} else {
									if (!regex.test(value)) {
										callback(new Error('请填写正确的银行卡号'));
									} else {
										callback();
									}
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bank_branch': [
						{
							required: true, validator: (rule, value, callback) => {
								if (!this.addForm.bank_of_deposit) {
									callback(new Error('请选择开户行'));
								} else if (!this.addForm.bank_branch) {
									callback(new Error('请选择支行'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'invoice_type': [
						{ required: true, message: '请选择发票类型', trigger: ['change'] }
					],
					'invoice_rate': [
						{ required: true, message: '请填写发票率', trigger: ['blur'] }
					],
					'refund_account': [
						{ required: true, message: '请选择回款账号', trigger: ['change'] }
					],
					'idcard_prove':[
						{
							required: true, validator: (rule, value, callback) => {
								if (this.addForm.invoice_prove.length < 1) {
									callback(new Error('请上传营业执照'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'invoice_prove':[
						{
							required: true, validator: (rule, value, callback) => {
								if ((this.addForm.type == 1 || this.addForm.type == 2) && this.addForm.invoice_prove.length < 1) {
									callback(new Error('请上传开户许可证'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'taxpayer_prove':[
							{
							required: true, validator: (rule, value, callback) => {
								if ((this.addForm.type == 1 || this.addForm.type == 2) && this.addForm.taxpayer_prove.length < 1) {
									callback(new Error('请上传一般纳税人证明'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'fp_attachment': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.addForm.fp_attachment.length < 1) {
									callback(new Error('请上传发票证明'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				editForm: {
					'type': [
						{ required: true, message: '请选择业务类型', trigger: ['change'] }
					],
					'rid': [
						{ required: true, message: '请选择', trigger: ['change'] }
					],
					'ird': [
						{ required: true, message: '请填写税号', trigger: ['change', 'blur'] },
						{
							pattern: /^[A-Za-z0-9]+$/,
							message: '只能包含字母和数字',
							trigger: ['change', 'blur'],
						}
					],
					'address': [
						{ required: true, message: '请填写公司地址', trigger: ['blur'] }
					],
					'company_name': [
						{ required: true, message: '请填写公司名称', trigger: ['blur'] }
					],
					'phone': [
						{ required: true, message: '请填写电话号码', trigger: ['change', 'blur'] },
						{
							validator: (rule, value, callback) => {
								const mobileRegex = /^1[3-9]\d{9}$/; // 手机号
								const landlineRegex = /^(0\d{2,3}-)?\d{7,8}$/; // 座机号
								if (!mobileRegex.test(value) && !landlineRegex.test(value) && value) {
									callback(new Error('请输入有效的手机号或座机号'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bank_card': [
						{
							required: true, validator: (rule, value, callback) => {
								const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
								if (!value) {
									callback(new Error('请填写银行卡号'));
								} else {
									if (!regex.test(value)) {
										callback(new Error('请填写正确的银行卡号'));
									} else {
										callback();
									}
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bank_branch': [
						{
							required: true, validator: (rule, value, callback) => {
								if (!this.editForm.bank_of_deposit) {
									callback(new Error('请选择开户行'));
								} else if (!this.editForm.bank_branch) {
									callback(new Error('请选择支行'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'invoice_type': [
						{ required: true, message: '请选择发票类型', trigger: ['change'] }
					],
					'invoice_rate': [
						{ required: true, message: '请填写发票率', trigger: ['blur'] }
					],
					'refund_account': [
						{ required: true, message: '请选择回款账号', trigger: ['change'] }
					],
					'idcard_prove':[
						{
							required: true, validator: (rule, value, callback) => {
								if (this.editForm.idcard_prove.length < 1) {
									callback(new Error('请上传营业执照'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'invoice_prove':[
						{
							required: true, validator: (rule, value, callback) => {
								if ((this.editForm.type == 1 || this.editForm.type == 2) && this.editForm.invoice_prove.length < 1) {
									callback(new Error('请上传开户许可证'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'taxpayer_prove':[
							{
							required: true, validator: (rule, value, callback) => {
								if ((this.editForm.type == 1 || this.editForm.type == 2) && this.editForm.taxpayer_prove.length < 1) {
									callback(new Error('请上传一般纳税人证明'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'fp_attachment': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.editForm.fp_attachment.length < 1) {
									callback(new Error('请上传发票证明'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
		}
	},
	computed: {

		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		//this.handleSearch(this.searchForm);
		this.requestKhh()//获取开户行
		this.getRemittanceBanck()//获取回款账户
	},
	methods: {
		handleTableDisableOpen(row){
			let txt = ''
			let is_disable_value = ''
			if(row['is_disable'] == 1){
				txt = '停用'
				is_disable_value = 2
			}else{
				txt = '启用'
				is_disable_value = 1
			}
			this.$confirm(`此操作将【${txt}】该开票信息, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
					this.$api.post('/admin/resources/resources/disableinvoice',{id:row['id'], is_disable:is_disable_value} ).then(res => {
						if (res.code == 0) {
							this.tableData.data.forEach((item,index)=>{
								if(item['id'] == row['id']){
									this.$set(this.tableData.data[index],'is_disable',is_disable_value)
									this.$set(this.tableData.data[index],'is_disable_txt',txt)
								}
							})
							this.$message({
								type: 'success',
								message: `${txt}成功!`
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
        })
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		exportData () {
			this.isDownloading = true;
			var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
			excelSearch.downloadType = 'invoice'
			this.$api.get('/admin/customers/export/exportinvoiceexcel', excelSearch).then(res => {
				// if (res.code == 0) {
				// 		this.$alert('异步下载任务【发票列表下载】创建成功！请稍后查看下载列表', '下载提示', {
				// 			confirmButtonText: '确定',
				// 		});
				// }else{
				// 	this.$message({
				// 		type: 'error',
				// 		message: res.msg
				// 	});
				// }
				// this.isDownloading = false;
				// 将Blob转换为URL以便创建一个可下载的链接
				const url = window.URL.createObjectURL(new Blob([res]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', '发票信息.xlsx'); // 设置下载文件名
				document.body.appendChild(link);
				link.click(); // 触发点击下载
				document.body.removeChild(link); // 下载后移除元素
				window.URL.revokeObjectURL(url); // 释放URL对象
				this.isDownloading = false
				this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
					confirmButtonText: '确定',
				});
			})
		},
		isDefault (row) {
			this.$api.post('/admin/resources/resources/invoicedefault', { id: row.id }).then(res => {
				if (res.code == 0) {
					var data = this.tableData.data
					data.forEach(function (item, index) {
						if (item.id == row.id) {
							if (item.is_default == 1) {
								this.$set(data[index], 'is_default', 0)
							} else {
								this.$set(data[index], 'is_default', 1)
							}
						}
					}.bind(this))
					this.$message.success('默认设置成功');
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//列表查询
		handleSearch (params, page, prop, order) {
			this.tableloading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/resources/resources/invoicelist', param).then(res => {
				if (res.code == 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.tableloading = false;
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加发票信息弹窗
		addInvoiceOpen () {
			this.addForm = {
				type: '',
				rid: '',
				company_name: '',
				ird: '',
				address: '',
				phone: '',
				bank_of_deposit: '',
				bank_branch: '',
				bank_card: '',
				invoice_type: '',
				invoice_type: '',
				refund_account: '',
				idcard_prove: [],
				invoice_prove: [],
				taxpayer_prove: [],
				fp_attachment: [],
				guanlian_prove: []
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.addFormVisiable = true;
		},
		// 添加发票信息
		addInvoice () {
			const formData = new FormData()
			let arr = ['idcard_prove', 'taxpayer_prove', 'invoice_prove', 'fp_attachment', 'guanlian_prove']
			for (const key in this.addForm) {
				if (arr.indexOf(key) != -1) {
					if (this.addForm[key].length > 0) {
						this.addForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.addForm[key]);
				}
			}
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/resources/resources/ctinvoice', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '发票信息添加成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		// 打开编辑发票信息弹窗
		handleTableEditOpen (row) {
			this.$api.get('/admin/resources/resources/invoiceinfo', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.editForm = res.data
					if (this.editForm.type) {
						this.getRidedit()
					}
					if (this.editForm.bank_of_deposit) {
						this.requestKhh()
						this.requestZh(this.editForm.bank_of_deposit, 'keep')
					}
					this.editFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 编辑发票信息
		handleTableEdit () {
			const formData = new FormData()
			let arr = ['idcard_prove', 'taxpayer_prove', 'invoice_prove', 'fp_attachment', 'guanlian_prove']
			for (const key in this.editForm) {
				if (arr.indexOf(key) != -1) {
					if (this.editForm[key].length > 0) {
						this.editForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.editForm[key]);
				}
			}
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/resources/resources/editinvoice', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch('', this.tableData.page);
							this.$message({
								showClose: true,
								message: '发票信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		// 删除发票信息
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该发票信息, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/resources/resources/delinvoice', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该发票信息已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'InvoiceDetail',
				query: { id: row.id, set_id: 12, type: 'detail' }
			});
		},
		//提交审批
		handleTableFlow (row) {
			this.$api.post('/admin/resources/resources/invoicesubmit', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该发票信息已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		getRid (query) {
			this.$api.get('/admin/resources/resources/gtcdlist', { type: this.addForm.type, query: query }).then(res => {
				if (res.code === 0) {
					this.options.rid_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
			if (this.addForm.type == 1) {
				this.addForm.ridLabel = '供应商'
			} else if (this.addForm.type == 2) {
				this.addForm.ridLabel = '客户'
			} else if (this.addForm.type == 3) {
				this.addForm.ridLabel = '平台'
			}
			this.addForm.rid = ''
			this.addForm.ird = ''
			this.addForm.company_name = ''
			this.addForm.refund_account = ''
			this.addForm.guanlian_prove = []
		},
		getRidedit (type, query) {
			this.$api.get('/admin/resources/resources/gtcdlist', { type: this.editForm.type, query: query }).then(res => {
				if (res.code === 0) {
					this.options.rid_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
			if (this.editForm.type == 1) {
				this.editForm.ridLabel = '供应商'
			} else if (this.editForm.type == 2) {
				this.editForm.ridLabel = '客户'
			} else if (this.editForm.type == 3) {
				this.editForm.ridLabel = '平台'
			}
			if (type == 'clear') {
				this.editForm.rid = ''
				this.editForm.ird = ''
				this.editForm.company_name = ''
				this.editForm.refund_account = ''
				this.editForm.guanlian_prove = []
			}
		},
		//获取回款账户
		getRemittanceBanck (query) {
			this.$api.get('/admin/customers/customer/getremittancebanck', { query: query }).then(res => {
				if (res.code === 0) {
					this.options.refund_account_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取开户行
		requestKhh () {
			this.$api.get('/admin/resources/resources/getbankname').then(res => {
				if (res.code === 0) {
					this.options.khh_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取支行
		requestZh (id, changetype) {
			//changetype为clear则清空关联，keep为编辑状态下默认的值不清空
			if (changetype == 'clear') {
				this.addForm.bank_branch = '';
				this.editForm.bank_branch = '';
			}
			this.$api.get('/admin/resources/resources/getbankname', { id: id }).then(res => {
				if (res.code === 0) {
					this.options.zh_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//点击查看大图
		viewImg (file) {
			if (!file.url) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.pdf')) {
					window.open(url)
				} else {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				}

			} else {
				//已上传
				if (file.name.includes('.pdf')) {
					window.open(file.url)
				} else {
					this.dialogImageUrl = file.url;
					this.dialogVisibleImg = true;
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}

		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/invoiceDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>